import { createContext } from 'react';

// Provides prefetched article data during SSR rendering.
// On the client, Article.jsx reads from article-ssr.js instead.
const ArticleSSRContext = createContext(null);

export default ArticleSSRContext;
